import {Alert, Checkbox, FormControlLabel, FormHelperText, Grid, TextField} from "@mui/material";
import {Fragment, useState} from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {MODE} from "../../Campaign/campaignMode";
import BasicDateTimePicker from "../../Utils/BasicDateTimePicker";
import {getDomainAlias} from "../../../constants";
import {abTestIdRegexp} from "../abTestFormModel";

dayjs.extend(utc);

const NAMING_RULES_URL = "https://belka-games.atlassian.net/wiki/spaces/BAC/pages/4008345627/Mephisto+Naming+Rules";

/** Шаг "basic" AB-теста. errorFields — массив ключей ошибок из validateBasic + 'abTestId' (id занят). */
export default function BasicStep({currentAbTest, mode, errorFields, handleChange, handleDateChange}) {
    const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
    const has = (key) => errorFields.includes(key);
    const idError = has('abTestId') || has('regexp') || has('abTestIdEmpty') || has('clone');

    return <Fragment>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    required
                    disabled={mode === MODE.UPDATE}
                    id="abTestId"
                    name="abTestId"
                    label="AB Test ID"
                    error={idError}
                    fullWidth
                    value={currentAbTest.abTestId}
                    onChange={handleChange}
                />
                {has('regexp') && <FormHelperText error>
                    AB Test ID must match the given regexp: {abTestIdRegexp(getDomainAlias()).toString()}. See <a href={NAMING_RULES_URL} target={"_blank"} rel="noreferrer">Mephisto Naming Rules</a>.
                </FormHelperText>}
                {has('abTestId') && <FormHelperText error>This id is already taken</FormHelperText>}
                {has('clone') && <FormHelperText error>Change AB Test ID, it shouldn't contain "Clone"</FormHelperText>}
            </Grid>
            <Grid item xs={6}>
                <BasicDateTimePicker
                    label="From (GMT+3)"
                    name="from"
                    value={currentAbTest.from}
                    onChange={handleDateChange}
                />
            </Grid>
            <Grid item xs={6}>
                <BasicDateTimePicker
                    label="Till (GMT+3)"
                    name="till"
                    value={currentAbTest.till}
                    onChange={handleDateChange}
                />
                {has('date') && <FormHelperText error>The end date must be after the start date</FormHelperText>}
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="abTestLink"
                    name="link"
                    label="Link"
                    fullWidth
                    value={currentAbTest.metaData?.link ?? ''}
                    error={has('link')}
                    helperText={has('link') ? "Link must be a valid URL to asana.com" : undefined}
                    onChange={handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <Alert severity="info">Помните, что From и Till – это даты набора игроков в когорты. По наступлению Till
                    игроки останутся в них, не потеряют свои когорты.</Alert>
            </Grid>
            <Grid item xs={12} style={{paddingTop: 3}} display={'flex'} justifyContent={'center'}>
                <span style={{textDecoration: 'underline dotted', cursor: 'pointer'}}
                      onClick={() => setShowAdvancedSettings(!showAdvancedSettings)}>
                    advanced settings
                </span>
            </Grid>
            {showAdvancedSettings &&
                <Fragment>
                    <Grid item xs={12}>
                        <TextField
                            id="groupId"
                            name="groupId"
                            label="Group ID"
                            value={currentAbTest.groupId}
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="priority"
                            name="priority"
                            label="Priority"
                            value={currentAbTest.priority}
                            fullWidth
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox name='reassignCohort' checked={!!currentAbTest.reassignCohort} onChange={handleChange}/>}
                            id="reassignCohort"
                            label="Reassign Cohort After Update"
                        />
                        {currentAbTest.reassignCohortDate != null && <FormHelperText>
                            Last reassign: {dayjs(currentAbTest.reassignCohortDate * 1000).utcOffset(180).format('YYYY-MM-DD HH:mm:ss')}
                        </FormHelperText>}
                        <div>
                            <FormControlLabel
                                control={<Checkbox name='assignCohortByPayments' checked={!!currentAbTest.assignCohortByPayments} onChange={handleChange}/>}
                                id="assignCohortByPayments"
                                label="Assign Cohort By Payments"
                            />
                        </div>
                    </Grid>
                </Fragment>}
        </Grid>
    </Fragment>;
}
